var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrashcomponent = function SvgTrashcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1C7.705 1 1 7.705 1 16s6.705 15 15 15 15-6.705 15-15S24.295 1 16 1Z",
    fill: "current",
    stroke: "#A08264"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 9c-.735 0-1.333.628-1.333 1.4v.7H10v1.4h1.333v9.1c0 .772.598 1.4 1.334 1.4h6.666c.736 0 1.334-.628 1.334-1.4v-9.1H22v-1.4h-2.667v-.7c0-.772-.598-1.4-1.333-1.4h-4Zm4 1.4v.7h-4v-.7h4Zm-5.333 11.2v-9.1h6.666v9.1h-6.666Zm2.666-7.7v6.3H14v-6.3h1.333Zm2.667 0v6.3h-1.333v-6.3H18Z",
    fill: "#A08264"
  })));
};
export default SvgTrashcomponent;